<template lang="pug">
  v-snackbar(:timeout="tiempo", :color="notaContent.color", top, v-model="nota") 
    span(:style={fontFamily: 'Roboto'}) {{notaContent.texto}}
    v-btn(dark flat @click.native="nota = false")
      v-icon clear
</template>

<script>
export default {
  data () {
    return {
      // notifications
      tiempo: 3000,
    }
  },
  computed: {
    nota: {
      get: function () {
        return this.$store.getters.nota
      },
      set: function () {
        this.$store.commit('nota', false)
      },
    },
    notaContent () {
      return this.$store.getters.notaContent
    }
  }
}
</script>

